// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyUpsearchModel {
    static getAttributeTypeMap() {
        return PharmacyUpsearchModel.attributeTypeMap;
    }
}
PharmacyUpsearchModel.discriminator = undefined;
PharmacyUpsearchModel.additionalProperties = false;
PharmacyUpsearchModel.attributeTypeMap = [
    {
        "name": "pharmacyId",
        "baseName": "pharmacyId",
        "type": "number"
    },
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": "Array<PharmacySharedAddressUpsearchModel>"
    },
    {
        "name": "contacts",
        "baseName": "contacts",
        "type": "Array<PharmacySharedContactUpsearchModel>"
    },
    {
        "name": "emailAddresses",
        "baseName": "emailAddresses",
        "type": "Array<PharmacySharedEmailAddressUpsearchModel>"
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": "Array<PharmacySharedPhoneUpsearchModel>"
    },
    {
        "name": "webAddresses",
        "baseName": "webAddresses",
        "type": "Array<PharmacySharedWebAddressUpsearchModel>"
    },
    {
        "name": "pharmacyName",
        "baseName": "pharmacyName",
        "type": "string"
    },
    {
        "name": "nabp",
        "baseName": "nabp",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "pharmacyType",
        "baseName": "pharmacyType",
        "type": "PharmacyType"
    },
    {
        "name": "pharmacySpecialization",
        "baseName": "pharmacySpecialization",
        "type": "PharmacySpecialization"
    },
];
//# sourceMappingURL=pharmacyUpsearchModel.js.map